import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollToBottom from "react-scroll-to-bottom";

import Note from "./Note/Note";
import SendForm from "./SendForm/SendForm";

import styles from "./Notes.scss";

class Notes extends Component {
  render() {
    return (
      <React.Fragment>
        <div className={styles.messages}>
          <ScrollToBottom
            className={styles.messagesContainer}
            scrollViewClassName={styles.messagesContainerScrollView}
          >
            {this.renderNotes()}
          </ScrollToBottom>
        </div>
        <SendForm onSubmit={this.props.submitNote} />
      </React.Fragment>
    );
  }

  renderNotes() {
    const { notes } = this.props;

    return (
      notes &&
      notes.map((note, key) => {
        const props = {
          note,
          key
        };

        return <Note {...props} />;
      })
    );
  }
}

const mapStateToProps = state => {
  return {
    notes: state.admin.notes
  };
};

export default connect(mapStateToProps)(Notes);



// WEBPACK FOOTER //
// ./src/routes/common/adminNotes/Notes.js